import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Image Icon
 *
 * @file Image.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Image = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.125 2H14.875C16.0486
        2 17 2.95139 17 4.125V13.875C17 15.0486 16.0486 16 14.875 16H3.125C1.95139
        16 1 15.0486 1 13.875V4.125C1 2.95139 1.95139 2 3.125 2ZM15.25
        10.4725V4.125C15.25 3.91789 15.0821 3.75 14.875 3.75H3.125C2.91789
        3.75 2.75 3.91789 2.75 4.125V12.8902L5.40648 9.43859C5.86964
        8.83679 6.73295 8.72441 7.33475 9.18757C7.39043 9.23197
        7.39044 9.23198 7.44291 9.28011L7.44292 9.28012L7.44293
        9.28013L8.3386 10.1306L10.4453 6.92984C10.8628 6.29552
        11.7155 6.11975 12.3498 6.53726C12.493 6.6315 12.6173
        6.75168 12.7163 6.89161L15.25 10.4725ZM11.6051 8.35087L15.25
        13.5023V13.875C15.25 14.0821 15.0821 14.25 14.875 14.25H3.91173L6.53957
        10.8356L7.67529 11.9141C8.12584 12.3419 8.83792 12.3235 9.26575
        11.8729L9.26576 11.8729C9.33233 11.7985 9.33233 11.7985 9.38967
        11.7168L11.6051 8.35087Z"
      fill="currentcolor"
    />
    <circle cx="5.5" cy="6.5" r="1.5" fill="currentcolor" />
  </SvgIcon>
);

export default Image;
